export default __webpack_public_path__ + "static/media/roboto-vietnamese-400-normal.52cebac0.woff2";